import { Site } from '@envato/foundation-types'

export default {
  [Site.themeforest]: {
    label: 'Web Themes & Templates',
    cross_site_links: [
      {
        label: 'WP Themes',
        url: 'https://themeforest.net/category/wordpress'
      },
      {
        label: 'HTML Templates',
        url: 'https://themeforest.net/category/site-templates'
      },
      {
        label: 'Shopify Themes',
        url: 'https://themeforest.net/category/ecommerce/shopify'
      },
      {
        label: 'Bootstrap Themes',
        url: 'https://themeforest.net/tags/bootstrap'
      },
      {
        label: 'Free WordPress Themes',
        url: 'https://themeforest.net/free/wordpress-themes'
      }
    ],
    internal_links: [
      {
        label: 'Portfolio WordPress Themes',
        url: 'https://themeforest.net/category/wordpress/creative/portfolio'
      },
      {
        label: 'Business WordPress Themes',
        url: 'https://themeforest.net/category/wordpress/corporate/business'
      },
      {
        label: 'Wedding Website Templates',
        url: 'https://themeforest.net/category/site-templates/wedding'
      },
      {
        label: 'Portfolio Website Templates',
        url:
          'https://themeforest.net/category/site-templates/creative/portfolio'
      },
      {
        label: 'Responsive Website Templates',
        url: 'https://themeforest.net/category/site-templates?tags=responsive'
      }
    ]
  },
  [Site.videohive]: {
    label: 'Video',
    cross_site_links: [
      {
        label: 'After Effects Templates',
        url: 'https://videohive.net/category/after-effects-project-files'
      },
      {
        label: 'Apple Motion Templates',
        url: 'https://videohive.net/category/apple-motion-templates'
      },
      {
        label: 'Video Effects',
        url: 'https://videohive.net/tags/effects'
      },
      {
        label: 'Lower Thirds',
        url: 'https://videohive.net/category/motion-graphics/lower-thirds'
      },
      {
        label: 'Stock Footage',
        url: 'https://videohive.net/category/stock-footage'
      }
    ],
    internal_links: [
      {
        label: 'Nature Stock Footage',
        url: 'https://videohive.net/category/stock-footage/nature'
      },
      {
        label: 'Corporate Stock Video',
        url: 'https://videohive.net/category/stock-footage/business-corporate'
      },
      {
        label: 'Apple Motion Openers',
        url: 'https://videohive.net/category/apple-motion-templates/openers'
      },
      {
        label: 'Food Stock Video',
        url: 'https://videohive.net/category/stock-footage/food'
      }
    ]
  },
  [Site.audiojungle]: {
    label: 'Audio',
    cross_site_links: [
      {
        label: 'Royalty Free Music',
        url: 'https://audiojungle.net/category/music'
      },
      {
        label: 'Sound Effects',
        url: 'https://audiojungle.net/category/sound'
      },
      {
        label: 'Best Selling Royalty Free Music',
        url: 'https://audiojungle.net/popular_item/by_category?category=music'
      },
      {
        label: 'Logic Pro Files',
        url: 'https://audiojungle.net/category/source-files/logic-pro'
      },
      {
        label: 'Background Music',
        url: 'https://audiojungle.net/tags/background'
      }
    ],
    internal_links: [
      {
        label: 'Game Sound Effects',
        url: 'https://audiojungle.net/category/sound/game-sounds'
      },
      {
        label: 'Popular Music Kits',
        url:
          'https://audiojungle.net/popular_item/by_category?category=music-kits'
      },
      {
        label: 'Cartoon Sound Effects',
        url: 'https://audiojungle.net/category/sound/cartoon-sounds'
      },
      {
        label: 'Intro Music',
        url: 'https://audiojungle.net/tags/intro'
      },
      {
        label: 'Computer Sound Effects',
        url: 'https://audiojungle.net/category/sound/futuristic-sounds'
      }
    ]
  },
  [Site.codecanyon]: {
    label: 'Code',
    cross_site_links: [
      {
        label: 'WordPress Plugins',
        url: 'https://codecanyon.net/category/wordpress'
      },
      {
        label: 'PHP Script',
        url: 'https://codecanyon.net/category/php-scripts'
      },
      {
        label: 'JavaScript',
        url: 'https://codecanyon.net/category/javascript'
      },
      {
        label: 'CSS Templates',
        url: 'https://codecanyon.net/category/css'
      },
      {
        label: 'PrestaShop Plugins',
        url: 'https://codecanyon.net/category/plugins/prestashop'
      }
    ],
    internal_links: [
      {
        label: 'JavaScript Animations',
        url: 'https://codecanyon.net/category/javascript?tags=animation'
      },
      {
        label: 'Android App Development',
        url: 'https://codecanyon.net/category/mobile/android'
      },
      {
        label: 'iOS Development',
        url: 'https://codecanyon.net/category/mobile/ios'
      },
      {
        label: 'WordPress SEO Plugins',
        url: 'https://codecanyon.net/category/wordpress/seo'
      },
      {
        label: 'WooCommerce Plugins',
        url: 'https://codecanyon.net/category/wordpress/ecommerce/woocommerce'
      }
    ]
  },
  [Site.graphicriver]: {
    label: 'Graphics',
    cross_site_links: [
      {
        label: 'Logo Templates',
        url: 'https://graphicriver.net/logo-templates'
      },
      {
        label: 'Business Card Templates',
        url: 'https://graphicriver.net/print-templates/business-cards'
      },
      {
        label: 'Lightroom Presets',
        url: 'https://graphicriver.net/add-ons/lightroom-presets'
      },
      {
        label: 'Serif Fonts',
        url: 'https://graphicriver.net/fonts/serif'
      },
      {
        label: 'Sans-serif Fonts',
        url: 'https://graphicriver.net/fonts/sans-serif'
      }
    ],
    internal_links: [
      {
        label: 'Stationery Templates',
        url: 'https://graphicriver.net/print-templates/stationery'
      },
      {
        label: 'Product Mockups',
        url: 'https://graphicriver.net/graphics/product-mock-ups'
      },
      {
        label: 'Google Slides Themes',
        url: 'https://graphicriver.net/presentation-templates/google-slides'
      },
      {
        label: 'Sketch Plugins',
        url: 'https://graphicriver.net/add-ons/sketch-plugins'
      }
    ]
  },
  [Site.photodune]: {
    label: 'Photos',
    cross_site_links: [
      {
        label: 'Food Stock Photos',
        url: 'https://photodune.net/tags/food'
      },
      {
        label: 'Animal Stock Photos',
        url: 'https://photodune.net/tags/animals'
      },
      {
        label: 'Tech Stock Photos',
        url: 'https://photodune.net/tags/technology'
      },
      {
        label: 'Fitness Stock Photos',
        url: 'https://photodune.net/tags/fitness,sports#content'
      },
      {
        label: 'Nature Stock Photos',
        url: 'https://photodune.net/tags/nature,travel#content'
      }
    ],
    internal_links: [
      {
        label: 'Business Stock Photos',
        url: 'https://photodune.net/tags/business'
      },
      {
        label: 'Dessert Stock Photos',
        url: 'https://photodune.net/tags/dessert,food#content'
      },
      {
        label: 'Architecture Stock Photos',
        url: 'https://photodune.net/tags/architecture'
      },
      {
        label: 'Popular Stock Photos',
        url: 'https://photodune.net/page/top_sellers'
      }
    ]
  },
  placeit: {
    label: 'Design Maker',
    cross_site_links: [
      {
        label: 'Logo Maker',
        url:
          'https://placeit.net/c/logos?utm_medium=promos&utm_source=envatoquicklinks&utm_campaign=placeit_mkt-quicklinks&utm_content=logo_quick-links'
      },
      {
        label: 'Business Card Maker',
        url:
          'https://placeit.net/c/design-templates/?f_devices=business%20card%20maker&h=36&utm_medium=promos&utm_source=envatoquicklinks&utm_campaign=placeit_mkt-quicklinks&utm_content=buscard_quick-links'
      },
      {
        label: 'T-Shirt Maker',
        url:
          'https://placeit.net/c/design-templates/?f_devices=t-shirt%20design&h=35&utm_medium=promos&utm_source=envatoquicklinks&utm_campaign=placeit_mkt-quicklinks&utm_content=tshirt-maker_quick-links'
      },
      {
        label: 'T-Shirt Mockups',
        url:
          'https://placeit.net/tshirt-mockup-generator?utm_medium=promos&utm_source=envatoquicklinks&utm_campaign=placeit_mkt-quicklinks&utm_content=tshirt-mockup_quick-links'
      },
      {
        label: 'iPhone Mockups',
        url:
          'https://placeit.net/c/mockups/?f_devices=iphone&h=10&utm_medium=promos&utm_source=envatoquicklinks&utm_campaign=placeit_mkt-quicklinks&utm_content=iphone_quick-links'
      }
    ],
    internal_links: [
      {
        label: 'Logo Maker',
        url:
          'https://placeit.net/c/logos?utm_medium=promos&utm_source=envatoquicklinks&utm_campaign=placeit_mkt-quicklinks&utm_content=logo_quick-links'
      },
      {
        label: 'Business Card Maker',
        url:
          'https://placeit.net/c/design-templates/?f_devices=business%20card%20maker&h=36&utm_medium=promos&utm_source=envatoquicklinks&utm_campaign=placeit_mkt-quicklinks&utm_content=buscard_quick-links'
      },
      {
        label: 'T-Shirt Maker',
        url:
          'https://placeit.net/c/design-templates/?f_devices=t-shirt%20design&h=35&utm_medium=promos&utm_source=envatoquicklinks&utm_campaign=placeit_mkt-quicklinks&utm_content=tshirt-maker_quick-links'
      },
      {
        label: 'T-Shirt Mockups',
        url:
          'https://placeit.net/tshirt-mockup-generator?utm_medium=promos&utm_source=envatoquicklinks&utm_campaign=placeit_mkt-quicklinks&utm_content=tshirt-mockup_quick-links'
      },
      {
        label: 'iPhone Mockups',
        url:
          'https://placeit.net/c/mockups/?f_devices=iphone&h=10&utm_medium=promos&utm_source=envatoquicklinks&utm_campaign=placeit_mkt-quicklinks&utm_content=iphone_quick-links'
      }
    ]
  },
  [Site.threedocean]: {
    label: '3D Files',
    cross_site_links: [
      {
        label: '3D Renders',
        url: 'https://3docean.net/category/3d-models'
      },
      {
        label: '3D  Car Models',
        url: 'https://3docean.net/category/3d-models/vehicles/land/cars'
      },
      {
        label: '3D Shaders',
        url: 'https://3docean.net/category/materials-and-shaders'
      },
      {
        label: 'CG Textures',
        url: 'https://3docean.net/category/cg-textures'
      },
      {
        label: 'OBJ Files',
        url: 'https://3docean.net/search?file_formats=obj'
      }
    ],
    internal_links: [
      {
        label: '3D Models',
        url: 'https://3docean.net/category/3d-models'
      },
      {
        label: 'CG Textures',
        url: 'https://3docean.net/category/cg-textures'
      },
      {
        label: 'HDRI Images',
        url: 'https://3docean.net/category/cg-textures/hdri-images'
      },
      {
        label: 'People 3D Models',
        url: 'https://3docean.net/category/3d-models/humans'
      },
      {
        label: 'Car 3D Models',
        url: 'https://3docean.net/category/3d-models/vehicles/land/cars'
      }
    ]
  },
  elements: {
    label: 'Elements',
    cross_site_links: [
      {
        label: 'WordPress Themes',
        url: 'https://elements.envato.com/wordpress/themes'
      },
      {
        label: 'Stock Images',
        url: 'https://elements.envato.com/photos'
      },
      {
        label: 'Website Templates',
        url: 'https://elements.envato.com/web-templates/site-templates'
      },
      {
        label: 'Logos',
        url: 'https://elements.envato.com/graphic-templates/logos'
      },
      {
        label: 'Fonts',
        url: 'https://elements.envato.com/fonts'
      }
    ],
    internal_links: [
      {
        label: 'Stock Photos',
        url: 'https://elements.envato.com/photos'
      },
      {
        label: 'Icons',
        url: 'https://elements.envato.com/graphics/icons'
      },
      {
        label: 'Keynote Templates',
        url:
          'https://elements.envato.com/presentation-templates/compatible-with-keynote'
      },
      {
        label: 'PowerPoint Templates',
        url:
          'https://elements.envato.com/presentation-templates/compatible-with-powerpoint'
      }
    ]
  },
  tuts: {
    label: 'Tuts+',
    cross_site_links: [
      {
        label: 'Photoshop Tutorials',
        url: 'https://design.tutsplus.com/categories/adobe-photoshop'
      },
      {
        label: 'JavaScript Tutorials',
        url: 'https://code.tutsplus.com/categories/javascript'
      },
      {
        label: 'WordPress Tutorials',
        url: 'https://code.tutsplus.com/categories/wordpress'
      },
      {
        label: 'Free Online Tutorials',
        url: 'https://tutsplus.com/tutorials'
      },
      {
        label: 'Free Coding Tutorials',
        url: 'https://code.tutsplus.com/tutorials'
      }
    ],
    internal_links: [
      {
        label: 'Learn Code',
        url: 'https://code.tutsplus.com'
      },
      {
        label: 'Learn Graphic Design',
        url: 'https://design.tutsplus.com/tutorials'
      },
      {
        label: 'Learn Business',
        url: 'https://business.tutsplus.com/tutorials'
      },
      {
        label: 'Learn Photography',
        url: 'https://photography.tutsplus.com/categories/photography'
      },
      {
        label: 'CryptoCurrency Tutorials & Ebooks',
        url: 'https://code.tutsplus.com/ebooks/search/Cryptocurrencies'
      }
    ]
  }
}
